import { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { authApi } from '@carrent/api'
import { useAuthStore } from '@carrent/core'
import { useLegal, fetchLegalDocument } from '@carrent/domain'
import { LegalConsent } from '@carrent/ui'

export default function RegisterPage() {
  const [form, setForm] = useState({
    full_name: '', phone: '', email: '', password: '', confirm: '',
  })
  const [err, setErr]       = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuthStore()
  const { legal } = useLegal()
  const navigate = useNavigate()

  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }))

  const handleSubmit = async (e) => {
    e.preventDefault()
    setErr('')
    if (form.password !== form.confirm) { setErr('Пароли не совпадают'); return }
    if (form.password.length < 6) { setErr('Пароль — минимум 6 символов'); return }
    setLoading(true)
    try {
      const { data } = await authApi.register({
        full_name: form.full_name.trim(),
        phone:     form.phone.trim(),
        email:     form.email.trim().toLowerCase() || undefined,
        password:  form.password,
      })
      const { user, access_token, refresh_token } = data.data
      login(user, access_token, refresh_token)
      navigate('/verify')
    } catch (e) {
      setErr(e.response?.data?.message || 'Ошибка регистрации')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{
      minHeight: '100dvh', display: 'flex', flexDirection: 'column',
      padding: 'var(--gap)', paddingTop: '2.5rem',
      background: 'var(--bg)', maxWidth: 480, margin: '0 auto',
    }}>
      <div style={{ marginBottom: 'var(--gap-lg)' }}>
        <Link to="/login" style={{ color: 'var(--text-muted)', fontSize: '1.5rem', textDecoration: 'none' }}>‹</Link>
      </div>

      <div style={{ marginBottom: 'var(--gap-lg)' }}>
        <h1 style={{ fontSize: '1.6rem' }}>Регистрация</h1>
        <p className="text-muted" style={{ marginTop: 4 }}>Шаг 1 из 4 — Личные данные</p>
      </div>

      {/* Progress */}
      <div className="step-progress" style={{ marginBottom: 'var(--gap-lg)' }}>
        <div className="step-progress__track">
          <div className="step-progress__fill" style={{ width: '25%' }} />
        </div>
      </div>

      <form onSubmit={handleSubmit} className="flex-col" style={{ gap: 'var(--gap)', flex: 1 }}>
        {err && <div className="alert alert--error">{err}</div>}

        <div className="field">
          <label className="field__label">
            ФИО <span style={{ color: 'var(--danger)' }}>*</span>
          </label>
          <input className="input" placeholder="Иванов Иван Иванович"
            value={form.full_name} onChange={set('full_name')} required />
        </div>

        <div className="field">
          <label className="field__label">
            Номер телефона <span style={{ color: 'var(--danger)' }}>*</span>
          </label>
          <input className="input" type="tel" inputMode="tel"
            placeholder="+7 900 123-45-67"
            value={form.phone} onChange={set('phone')} required
            autoComplete="tel"
            style={{ fontSize: '1.05rem' }} />
          <span style={{ fontSize: '0.78rem', color: 'var(--text-muted)', marginTop: 4, display: 'block' }}>
            Используется для входа в систему
          </span>
        </div>

        <div className="field">
          <label className="field__label">Email (необязательно)</label>
          <input className="input" type="email" placeholder="для уведомлений"
            value={form.email} onChange={set('email')} autoComplete="email" />
        </div>

        <div className="field">
          <label className="field__label">
            Пароль <span style={{ color: 'var(--danger)' }}>*</span>
          </label>
          <input className="input" type="password" placeholder="Минимум 6 символов"
            value={form.password} onChange={set('password')} required
            autoComplete="new-password" />
        </div>

        <div className="field">
          <label className="field__label">
            Повторите пароль <span style={{ color: 'var(--danger)' }}>*</span>
          </label>
          <input className="input" type="password" placeholder="Повторите пароль"
            value={form.confirm} onChange={set('confirm')} required
            autoComplete="new-password" />
        </div>

        <button className="btn btn--primary btn--full" type="submit" disabled={loading}
          style={{ height: 52, fontSize: '1rem', marginTop: 4 }}>
          {loading ? <span className="spinner" /> : 'Продолжить →'}
        </button>

        {/* Под кнопкой, а не над ней: текст описывает последствие
            нажатия и должен читаться в момент, когда до кнопки
            уже дошли. */}
        <LegalConsent legal={legal} fetchDocument={fetchLegalDocument} />

        <p className="text-center text-muted" style={{ fontSize: '0.88rem' }}>
          Уже есть аккаунт?{' '}
          <Link to="/login" style={{ color: 'var(--accent)', fontWeight: 600 }}>Войти</Link>
        </p>
      </form>
    </div>
  )
}
